import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Clock } from "lucide-react";

export function JustifiedWindow({ sid, from, to, defFrom, defTo, onChange }) {
  const [open, setOpen] = useState(!!(from || to));
  if (!open) {
    return (
      <button type="button" onClick={() => { setOpen(true); onChange({ justified_from: defFrom || "", justified_to: defTo || "" }); }}
        className="h-9 px-2 rounded-lg border border-stone-200 text-[11px] text-stone-600 hover:bg-stone-50 inline-flex items-center gap-1"
        data-testid={`justify-hours-btn-${sid}`} title="Giustifica solo alcune ore">
        <Clock size={12} /> Ore giust.
      </button>
    );
  }
  return (
    <div className="flex items-center gap-1 rounded-lg border border-stone-300 bg-stone-50 px-1.5 py-1" data-testid={`justify-hours-${sid}`}>
      <span className="text-[10px] uppercase tracking-wide text-stone-500">Giust.</span>
      <Input type="time" value={from || ""} onChange={(e) => onChange({ justified_from: e.target.value })} className="w-[88px] h-7 text-xs" data-testid={`justify-from-${sid}`} />
      <span className="text-xs text-stone-400">–</span>
      <Input type="time" value={to || ""} onChange={(e) => onChange({ justified_to: e.target.value })} className="w-[88px] h-7 text-xs" data-testid={`justify-to-${sid}`} />
      <button type="button" className="text-xs text-stone-400 hover:text-red-600 px-1" title="Togli ore giustificate"
        onClick={() => { setOpen(false); onChange({ justified_from: "", justified_to: "" }); }} data-testid={`justify-clear-${sid}`}>×</button>
    </div>
  );
}
